import type {
  MultipleAvailableOpportunity,
  SingleAvailableOpportunity
} from '@ps/web-sports-api-types';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  getIsMultipleOpportunity,
  getIsSingleOpportunity
} from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { select } from '@swf/core/store';
import { Odds } from '@swf/sports/components';

import useHaveOddsChangedWithinDuration from '../../../../../../../../hooks/useHaveOddsChangedWithinDuration';
import useIsMultipleStartingPriceOpportunity from '../../../../../../../../hooks/useIsMultipleStartingPriceOpportunity';
import useOpportunityOddsChanges from '../../../../../../../../hooks/useOpportunityOddsChanges';
import StartingPriceToggle from '../StartingPriceToggle/StartingPriceToggle';

import styles from './OddsDisplay.scss';

interface Props {
  opportunity: SingleAvailableOpportunity | MultipleAvailableOpportunity;
}

const OddsDisplay: React.FC<Props> = ({ opportunity }) => {
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const { haveOddsChangedWithinDuration } = useHaveOddsChangedWithinDuration(opportunity);
  const { haveOddsChanged } = useOpportunityOddsChanges(opportunity);
  const isMultipleStartingPriceOpportunity = useIsMultipleStartingPriceOpportunity(opportunity);

  const isSingle = getIsSingleOpportunity(opportunity);

  if (isSingle && opportunity.isStartingPriceOpportunity) {
    return <StartingPriceToggle opportunity={opportunity} />;
  }

  if (opportunity.winRunnerOdds) {
    if (
      (isSingle && !opportunity.isStartingPriceOpportunity) ||
      (getIsMultipleOpportunity(opportunity) && !isMultipleStartingPriceOpportunity)
    ) {
      return (
        <div
          className={classNames(styles.odds, {
            [styles.oddsChanged]:
              (hasAutoAcceptEnabled && haveOddsChangedWithinDuration) ||
              (haveOddsChanged && !hasAutoAcceptEnabled)
          })}
        >
          <Odds {...opportunity.winRunnerOdds} />
        </div>
      );
    }
  }

  return null;
};

export default OddsDisplay;
